import React from "react";

type SettingIconProps = React.SVGProps<SVGSVGElement>;

export const SettingIcon = ({
  width = 20,
  height = 20,
  ...props
}: SettingIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.5825 5.47391C6.3431 5.49616 6.10171 5.46634 5.87492 5.38651L4.49992 4.90317C3.7353 5.72723 3.1657 6.71264 2.83325 7.78651L3.94159 8.73651C4.12398 8.89297 4.27039 9.08703 4.37076 9.30538C4.47113 9.52372 4.5231 9.76119 4.5231 10.0015C4.5231 10.2418 4.47113 10.4793 4.37076 10.6976C4.27039 10.916 4.12398 11.11 3.94159 11.2665L2.83325 12.2165C3.16594 13.2905 3.73583 14.2759 4.50075 15.0998L5.87492 14.6165C6.10171 14.5367 6.3431 14.5069 6.5825 14.5291C6.82191 14.5513 7.05367 14.6251 7.26187 14.7454C7.47007 14.8656 7.6498 15.0295 7.7887 15.2258C7.9276 15.422 8.0224 15.646 8.06659 15.8823L8.33492 17.3157C9.43143 17.5655 10.5701 17.5655 11.6666 17.3157L11.9324 15.8823C11.9766 15.646 12.0714 15.422 12.2103 15.2258C12.3492 15.0295 12.5289 14.8656 12.7371 14.7454C12.9453 14.6251 13.1771 14.5513 13.4165 14.5291C13.6559 14.5069 13.8973 14.5367 14.1241 14.6165L15.4991 15.0998C16.264 14.2759 16.8339 13.2905 17.1666 12.2165L16.0583 11.2673C15.8757 11.1109 15.7292 10.9168 15.6287 10.6983C15.5283 10.4799 15.4763 10.2423 15.4763 10.0019C15.4763 9.7615 15.5283 9.52393 15.6287 9.3055C15.7292 9.08708 15.8757 8.89297 16.0583 8.73651L17.1666 7.78651C16.8339 6.71256 16.264 5.72715 15.4991 4.90317L14.1249 5.38651C13.8981 5.46634 13.6567 5.49616 13.4173 5.47391C13.1779 5.45166 12.9462 5.37788 12.738 5.25763C12.5298 5.13738 12.35 4.9735 12.2111 4.77725C12.0722 4.581 11.9774 4.35701 11.9333 4.12067L11.6649 2.68734C10.5684 2.43755 9.42976 2.43755 8.33325 2.68734L8.06659 4.12067C8.0224 4.35701 7.9276 4.581 7.7887 4.77725C7.6498 4.9735 7.47007 5.13738 7.26187 5.25763C7.05367 5.37788 6.82191 5.45166 6.5825 5.47391Z"
      stroke="#79808A"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="10"
      cy="10"
      r="2.5"
      stroke="#79808A"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SettingIcon;
